import type { WysiwygEditorOption, WysiwygLinkFieldValues } from './types';

export const EMPTY_EDITOR_HTML = '<p></p>';
export const MIN_EDITOR_BODY_HEIGHT = 78;
export const MAX_EDITOR_BODY_HEIGHT = 360;
export const HTML_EDITOR_TOP_SCROLL_MARGIN = 10;
export const HTML_EDITOR_BOTTOM_SCROLL_MARGIN = 8;
export const LINK_CONTEXT_POPUP_MAX_WIDTH = 330;
export const LINK_CONTEXT_POPUP_EDGE_MARGIN = 8;
export const SUPPORTED_SOURCE_LINK_PROTOCOLS = [
  'http:',
  'https:',
  'ftp:',
  'mailto:',
  'tel:',
  'ted:',
];
export const UNSAFE_LINK_PROTOCOLS = ['javascript:', 'data:', 'vbscript:'];
export const INSERT_BUTTON_LABEL = 'Button Text';
export const INSERT_TABLE_ROW_COUNT = 3;
export const INSERT_TABLE_COLUMN_COUNT = 3;
export const TABLE_CONTROL_GAP = 4;
export const TABLE_CONTROL_SIZE = 16;
export const TABLE_ROW_HANDLE_SIZE = 28;
export const TABLE_COLUMN_HANDLE_TOP_OFFSET = 36;
export const EMPTY_LINK_SELECT_VALUE = '';

export const EMPTY_LINK_FIELD_VALUES: WysiwygLinkFieldValues = {
  'website-url': '',
  'folder-id': EMPTY_LINK_SELECT_VALUE,
  'page-id': EMPTY_LINK_SELECT_VALUE,
  'item-id': EMPTY_LINK_SELECT_VALUE,
  'app-id': EMPTY_LINK_SELECT_VALUE,
  'anchor-name': '',
  'link-text': '',
};

export const WYSIWYG_EDITOR_FOLDERS: WysiwygEditorOption[] = [
  { value: 'spa', label: 'Spa' },
  { value: 'dining', label: 'Dining' },
  { value: 'offers', label: 'Offers' },
];

export const WYSIWYG_EDITOR_PAGES: WysiwygEditorOption[] = [
  { value: 'wellness', label: 'Wellness', folderId: 'spa' },
  { value: 'restaurant', label: 'Restaurant', folderId: 'dining' },
  { value: 'special-offers', label: 'Special Offers', folderId: 'offers' },
];

export const WYSIWYG_EDITOR_ITEMS: WysiwygEditorOption[] = [
  {
    value: 'classic-massage',
    label: 'Classic Massage',
    folderId: 'spa',
    pageId: 'wellness',
  },
  {
    value: 'breakfast',
    label: 'Breakfast',
    folderId: 'dining',
    pageId: 'restaurant',
  },
  {
    value: 'late-checkout',
    label: 'Late Checkout',
    folderId: 'offers',
    pageId: 'special-offers',
  },
];

export const WYSIWYG_EDITOR_APPS: WysiwygEditorOption[] = [
  { value: 'room-service', label: 'Room Service' },
  { value: 'front-office', label: 'Front Office' },
  { value: 'suitepad-app', label: 'SuitePad App' },
];
